/**
 * Created by Nisarg on 7/13/2017.
 */
import React, {Component} from 'react';
import {TabContent, TabPane, Nav, NavItem, NavLink} from 'reactstrap';
import TinyMCE from 'react-tinymce';
import classnames from 'classnames';
import firebase from 'firebase';
import $ from 'jquery';
import _HauteFire from '../../Utils/HauteFire';

const HauteFire = new _HauteFire();


export default class HomePage extends Component {
    constructor() {
        super();

        this.toggle = this.toggle.bind(this);
        this.state = {
            HauteDetails: [],
            bannerTitleEditable: false,
            bannerContentEditable: false,
            bottomContentEditable: false,
            yashContentEditable: false,
            anushkaContentEditable: false,
            amitContentEditable: false,
            anchalContentEditable: false,
            pranavContentEditable: false,
            fileBanner: {},
            fileBottom: {},
            activeTab: '1'
        };
    }

    componentWillMount() {
        // this.getHauteDetails();
        // React.allowContentEditableChildren(true);
    }

    componentDidMount() {
        this.getHauteDetails();

        $(document).on("drop", "div.islandlogo", (e) => this.dropIslandLogo(e));
        $(document).on("dragover", "div.islandlogo", (e) => this.dropOverIslandLogo(e));
        $(document).on("dragstart", "img.img-islandlogo", (e) => this.dragStartIslandLogo(e));
    }

    getHauteDetails() {
        const _this = this;

        let hauteRef = firebase.database().ref('HauteDetails/');
        hauteRef.on('value', ((response) => {
            let HauteDetails = response.val();
            if (HauteDetails != null) {
                let logoUrls = HauteDetails.logoUrls;
                if (logoUrls != null) {
                    let keys = Object.keys(logoUrls);
                    logoUrls = keys.map((key) => {
                        return logoUrls[key]
                    });
                    HauteDetails.logoUrls = logoUrls;
                }

                _this.setState({HauteDetails});
            }
        }))
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    changeBannerPicture(e) {
        let _file = e.currentTarget.files[0];
        if (_file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                $("#imgIslandBanner").attr("src", e.target.result);
            };
            reader.readAsDataURL(_file);
            this.setState({fileBanner: _file});
        }
    }

    changeBottomPicture(e) {
        let _file = e.currentTarget.files[0];
        if (_file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                $("#imgIslandBottom").attr("src", e.target.result);
            };
            reader.readAsDataURL(_file);
            this.setState({fileBottom: _file});
        }
    }

    setIslandLogosHtml() {
        $("div#divIslandLogos").html("");

        let files = this.state.HauteDetails.logoUrls;

        files = files.sort((a, b) => {
            return parseInt(a.order) - parseInt(b.order)
        });
        // for (let file of files) {
        for (let i = 0; i < files.length; i++) {
            if (files[i]) {
                let _html = "";

                _html = '<div class="col-md-2 islandlogo"  data-id=' + files[i].id + ' data-order=' + files[i].order + '> \
                            <div class="imgcard imgcard-cascade wider"> \
                                <div class="view overlay hm-white-slight"> \
                                    <img src=' + files[i].url + ' alt="Island Picture" class="img-fluid img-islandlogo" draggable="true" data-id=' + files[i].id + ' data-name=' + files[i].name + ' data-order=' + files[i].order + ' data-islandId="' + files[i].islandId + '" data-islandName="' + files[i].islandName + '" /> \
                                </div> \
                            </div> \
                        </div>';

                $("div#divIslandLogos").append(_html);
            }
        }
    }

    dropIslandLogo(e) {
        e.preventDefault();
        e = e.originalEvent;
        const fromDraglogo = JSON.parse(e.dataTransfer.getData("fromDragLogo"));
        let id = $(e.target).attr("data-id");
        let islandId = $(e.target).attr("data-islandId");
        let islandName = $(e.target).attr("data-islandName");
        let name = $(e.target).attr("data-name");
        let order = $(e.target).attr("data-order");

        // let currentDiv = $("div.islandlogo[data-id=" + id + "]");
        // let currentLogoPath = $(currentDiv).find("img.img-islandlogo").attr("src");
        // let alternateDiv = $("div.islandlogo[data-id=" + fromDraglogo.id + "]");
        // let alternateLogoPath = $(alternateDiv).find("img.img-islandlogo").attr("src");
        //
        // $(currentDiv).attr("data-id", fromDraglogo.id);
        // // $(currentDiv).attr("data-order", fromDraglogo.order);
        // $(currentDiv).find("img.img-islandlogo").attr("src", alternateLogoPath);
        // $(currentDiv).find("img.img-islandlogo").attr("data-id", fromDraglogo.id);
        // // $(currentDiv).find("img.img-islandlogo").attr("data-order", fromDraglogo.order);
        //
        // $(alternateDiv).attr("data-id", id);
        // // $(alternateDiv).attr("data-order", order);
        // $(alternateDiv).find("img.img-islandlogo").attr("src", currentLogoPath);
        // $(alternateDiv).find("img.img-islandlogo").attr("data-id", id);
        // // $(alternateDiv).find("img.img-islandlogo").attr("data-order", order);

        let HauteDetails = this.state.HauteDetails;
        let islandLogos = HauteDetails.logoUrls;
        let currentLogo = islandLogos.filter((file) => {
            return file.id == id
        });
        let currentLogoName = currentLogo[0].name;
        let currentLogoIslandId = currentLogo[0].islandId;
        let currentLogoIslandName = currentLogo[0].islandName;
        let currentLogoUrl = currentLogo[0].url;
        let alternateLogo = islandLogos.filter((file) => {
            return file.id == fromDraglogo.id
        });
        let alternateLogoName = alternateLogo[0].name;
        let alternateLogoUrl = alternateLogo[0].url;

        islandLogos = islandLogos.map((file) => {
            if (file.id == id) {
                file.id = fromDraglogo.id;
                file.islandId = fromDraglogo.islandId;
                file.islandName = fromDraglogo.islandName;
                file.name = fromDraglogo.name;
                file.url = alternateLogoUrl;
                // file.order = parseInt(fromDraglogo.order);
            }
            else if (file.id == fromDraglogo.id) {
                file.id = id;
                file.islandId = islandId;
                file.islandName = islandName;
                file.name = name;
                file.url = currentLogoUrl;
                // file.order = parseInt(order);
            }

            return file;
        });

        this.setState({HauteDetails: HauteDetails});
    }

    dropOverIslandLogo(e) {
        e.preventDefault();
    }

    dragStartIslandLogo(e) {
        let id = $(e.currentTarget).attr("data-id");
        let islandId = $(e.currentTarget).attr("data-islandId");
        let islandName = $(e.currentTarget).attr("data-islandName");
        let name = $(e.currentTarget).attr("data-name");
        let order = $(e.currentTarget).attr("data-order");

        const fromDragLogo = {id, islandId, islandName, name, order};

        e = e.originalEvent;
        e.dataTransfer.setData("fromDragLogo", JSON.stringify(fromDragLogo));
    }

    changeAboutUs(e) {
        let HauteDetails = this.state.HauteDetails;
        HauteDetails.aboutUs = e.target.getContent();
        this.setState({HauteDetails});
    }

    saveHomepage() {
        $("#btnSaveHauteDetails").attr("disabled", "disabled");
        $("#btnSaveHauteDetails").html('<i class="fa fa-spinner fa-spin fa-fw"></i> Saving');

        if (!$.isEmptyObject(this.state.fileBanner) || !$.isEmptyObject(this.state.fileBottom)) {
            const _this = this;

            function* homeGenerator() {
                let homePictures = [];
                if (!$.isEmptyObject(_this.state.fileBanner)) {
                    let bannerUrl = yield HauteFire.uploadFile(_this.state.fileBanner, "HomePage/Banner/");
                    homePictures.push({bannerUrl});
                }
                if (!$.isEmptyObject(_this.state.fileBottom)) {
                    let bottomUrl = yield HauteFire.uploadFile(_this.state.fileBottom, "HomePage/Bottom/");
                    homePictures.push({bottomUrl});
                }
                return homePictures;
            }

            function homeWrapper() {
                const gen = homeGenerator();

                function handle(yielded) {
                    if (!yielded.done) {
                        yielded.value.then((url) => {
                            return handle(gen.next(url));
                        })
                    }
                    else {
                        let HauteDetails = _this.state.HauteDetails;
                        let bannerUrl = yielded.value.filter((obj) => {
                            return obj.bannerUrl
                        })[0];
                        if (bannerUrl) {
                            _this.state.HauteDetails.bannerPicUrl = bannerUrl.bannerUrl;
                        }
                        let bottomUrl = yielded.value.filter((obj) => {
                            return obj.bottomUrl
                        })[0];
                        if (bottomUrl) {
                            _this.state.HauteDetails.bottomPicUrl = bottomUrl.bottomUrl;
                        }

                        HauteFire.addUpdate("", _this.state.HauteDetails, "HauteDetails");

                        $("#btnSaveHauteDetails").removeAttr("disabled");
                        $("#btnSaveHauteDetails").html('<i class="fa fa-floppy-o" aria-hidden="true"></i> SAVE');
                    }
                }

                handle(gen.next());
            }

            homeWrapper();
        }
        else {
            HauteFire.addUpdate("", this.state.HauteDetails, "HauteDetails");

            $("#btnSaveHauteDetails").removeAttr("disabled");
            $("#btnSaveHauteDetails").html('<i class="fa fa-floppy-o" aria-hidden="true"></i> SAVE');
        }
    }

    renderBanner() {
        return (
            <div data-reactroot="" className="flex-row align-items-center">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="imgcard-group mb-0">
                                <div className="imgcard imgcard-cascade wider">
                                    <div className="view overlay hm-white-slight">
                                        <img id="imgIslandBanner"
                                             src={typeof this.state.HauteDetails.bannerPicUrl != typeof undefined ? this.state.HauteDetails.bannerPicUrl : this.state.HauteDetails.default.bannerPicUrl}
                                             alt="Island Banner" className="img-fluid"
                                        />
                                        <a onClick={(e) => {
                                            $("#fileBannerPicture").click();
                                        }}>
                                            <div className="mask waves-effect waves-light">
                                                <input id="fileBannerPicture" type="file" accept="image/*"
                                                       onChange={(e) => this.changeBannerPicture(e)}
                                                       style={{display: 'none'}}
                                                />
                                            </div>
                                        </a>
                                    </div>
                                    <div className="imgcard-block text-center">
                                        <h1 id="bannerTitle"
                                            style={{textTransform: 'uppercase', fontFamily: 'Fjalla One'}}
                                            contentEditable={this.state.bannerTitleEditable}
                                            onClick={(e) => {
                                                this.setState({bannerTitleEditable: true})
                                            }}
                                            onKeyUp={(e) => {
                                                if (e.keyCode == 13) {
                                                    let bannerTitle = e.currentTarget.innerText.trim();
                                                    e.currentTarget.innerText = bannerTitle;

                                                    let HauteDetails = this.state.HauteDetails;
                                                    HauteDetails.bannerTitle = bannerTitle;
                                                    this.setState({HauteDetails});

                                                    this.setState({bannerTitleEditable: false})
                                                }
                                            }}
                                        >
                                            {this.state.HauteDetails.bannerTitle != undefined || "" ? this.state.HauteDetails.bannerTitle : this.state.HauteDetails.default.bannerTitle}
                                        </h1>

                                        <p id="bannerContent" contentEditable={this.state.bannerContentEditable}
                                           onClick={(e) => {
                                               this.setState({bannerContentEditable: true});
                                           }}
                                           onKeyUp={(e) => {
                                               if (e.keyCode == 13) {
                                                   let bannerContent = e.currentTarget.innerText.trim();
                                                   e.currentTarget.innerText = bannerContent;

                                                   let HauteDetails = this.state.HauteDetails;
                                                   HauteDetails.bannerContent = bannerContent;
                                                   this.setState({HauteDetails});

                                                   this.setState({bannerContentEditable: false})
                                               }
                                           }}
                                        >
                                            {this.state.HauteDetails.bannerContent != undefined || "" ? this.state.HauteDetails.bannerContent : this.state.HauteDetails.default.bannerContent}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-md-12">
                            <div className="imgcard-group mb-0">
                                <div className="imgcard imgcard-cascade wider">
                                    <div className="view overlay hm-white-slight">
                                        <img id="imgIslandBottom"
                                             src={this.state.HauteDetails.bottomPicUrl != undefined || "" ? this.state.HauteDetails.bottomPicUrl : this.state.HauteDetails.default.bottomPicUrl}
                                             alt="Island Banner" className="img-fluid"
                                        />
                                        <a onClick={(e) => {
                                            $("#fileBottomPicture").click();
                                        }}>
                                            <div className="mask waves-effect waves-light">
                                                <input id="fileBottomPicture" type="file" accept="image/*"
                                                       onChange={(e) => this.changeBottomPicture(e)}
                                                       style={{display: 'none'}}
                                                />
                                            </div>
                                        </a>
                                    </div>
                                    <div className="imgcard-block text-center">
                                        <p id="bottomContent" contentEditable={this.state.bottomContentEditable}
                                           onClick={(e) => {
                                               this.setState({bottomContentEditable: true});
                                           }}
                                           onKeyUp={(e) => {
                                               if (e.keyCode == 13) {
                                                   let bottomContent = e.currentTarget.innerText.trim();
                                                   e.currentTarget.innerText = bottomContent;

                                                   let HauteDetails = this.state.HauteDetails;
                                                   HauteDetails.bannerContent = bottomContent;
                                                   this.setState({HauteDetails});

                                                   this.setState({bottomContentEditable: false})
                                               }
                                           }}
                                        >
                                            {this.state.HauteDetails.bottomContent != undefined || "" ? this.state.HauteDetails.bottomContent : this.state.HauteDetails.default.bottomContent}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    renderAboutus() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12 col-md-12">
                        <TinyMCE
                            content={this.state.HauteDetails.aboutUs != undefined || "" ? this.state.HauteDetails.aboutUs : this.state.HauteDetails.default.aboutUs}
                            onChange={this.changeAboutUs.bind(this)}
                        />
                    </div>
                </div>
                <br/>
                <div className="row">
                    <div className="col-sm-12 col-md-12">
                        <div className="card card-accent-warning">
                            <div className="card-header" style={{fontFamily: 'Fjalla One'}}>
                                Yash Churiwala, Co-founder
                            </div>
                            <div className="card-block" contentEditable={this.state.yashContentEditable}
                                 onClick={(e) => {
                                     this.setState({yashContentEditable: true});
                                 }}
                                 onKeyUp={(e) => {
                                     if (e.keyCode == 13) {
                                         let yashContent = e.currentTarget.innerText.trim();
                                         e.currentTarget.innerText = yashContent;

                                         let HauteDetails = this.state.HauteDetails;
                                         let partners = HauteDetails.partners;
                                         let yash = partners[0];
                                         yash.about = yashContent;

                                         this.setState({HauteDetails});

                                         this.setState({yashContentEditable: false})
                                     }
                                 }}>
                                {this.state.HauteDetails.partners[0].about}
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <div className="row">
                    <div className="col-sm-12 col-md-12">
                        <div className="card card-accent-primary">
                            <div className="card-header" style={{fontFamily: 'Fjalla One'}}>
                                Anushka Patodia, Co-founder
                            </div>
                            <div className="card-block" contentEditable={this.state.anushkaContentEditable}
                                 onClick={(e) => {
                                     this.setState({anushkaContentEditable: true});
                                 }}
                                 onKeyUp={(e) => {
                                     if (e.keyCode == 13) {
                                         let anushkaContent = e.currentTarget.innerText.trim();
                                         e.currentTarget.innerText = anushkaContent;

                                         let HauteDetails = this.state.HauteDetails;
                                         let partners = HauteDetails.partners;
                                         let anushka = partners[1];
                                         anushka.about = anushkaContent;

                                         this.setState({HauteDetails});

                                         this.setState({anushkaContentEditable: false})
                                     }
                                 }}>
                                {this.state.HauteDetails.partners[1].about}
                            </div>
                        </div>
                    </div>
                </div>

                <br/>
                <div className="row">
                    <div className="col-sm-12 col-md-12">
                        <div className="card card-accent-danger">
                            <div className="card-header" style={{fontFamily: 'Fjalla One'}}>
                                Amit Pareek, CTO
                            </div>
                            <div className="card-block" contentEditable={this.state.amitContentEditable}
                                 onClick={(e) => {
                                     this.setState({amitContentEditable: true});
                                 }}
                                 onKeyUp={(e) => {
                                     if (e.keyCode == 13) {
                                         let amitContent = e.currentTarget.innerText.trim();
                                         e.currentTarget.innerText = amitContent;

                                         let HauteDetails = this.state.HauteDetails;
                                         let partners = HauteDetails.partners;
                                         let amit = partners[2];
                                         amit.about = amitContent;

                                         this.setState({HauteDetails});

                                         this.setState({amitContentEditable: false})
                                     }
                                 }}>
                                {this.state.HauteDetails.partners[2].about}
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <div className="row">
                    <div className="col-sm-12 col-md-12">
                        <div className="card card-accent-success">
                            <div className="card-header" style={{fontFamily: 'Fjalla One'}}>
                                {this.state.HauteDetails.partners[3].title}
                            </div>
                            <div className="card-block" contentEditable={this.state.anchalContentEditable}
                                 onClick={(e) => {
                                     this.setState({anchalContentEditable: true});
                                 }}
                                 onKeyUp={(e) => {
                                     if (e.keyCode == 13) {
                                         let anchalContent = e.currentTarget.innerText.trim();
                                         e.currentTarget.innerText = anchalContent;

                                         let HauteDetails = this.state.HauteDetails;
                                         let partners = HauteDetails.partners;
                                         let anchal = partners[3];
                                         anchal.about = anchalContent;

                                         this.setState({HauteDetails});

                                         this.setState({anchalContentEditable: false})
                                     }
                                 }}>
                                {this.state.HauteDetails.partners[3].about}
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <div className="row">
                    <div className="col-sm-12 col-md-12">
                        <div className="card card-accent-secondary">
                            <div className="card-header" style={{fontFamily: 'Fjalla One'}}>
                                Pranav Parikh, Investor
                            </div>
                            <div className="card-block" contentEditable={this.state.pranavContentEditable}
                                 onClick={(e) => {
                                     this.setState({pranavContentEditable: true});
                                 }}
                                 onKeyUp={(e) => {
                                     if (e.keyCode == 13) {
                                         let pranavContent = e.currentTarget.innerText.trim();
                                         e.currentTarget.innerText = pranavContent;

                                         let HauteDetails = this.state.HauteDetails;
                                         let advisoryBoard = HauteDetails.advisoryBoard;
                                         advisoryBoard.about = pranavContent;

                                         this.setState({HauteDetails});

                                         this.setState({pranavContentEditable: false})
                                     }
                                 }}>
                                {this.state.HauteDetails.advisoryBoard.about}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderIslandLogos() {
        return (
            <div data-reactroot="" className="flex-row align-items-center">

                <br/><br/><br/>

                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12">
                            <div id="divIslandLogos" className="form-group row">
                                {!$.isEmptyObject(this.state.HauteDetails.logoUrls) ? this.setIslandLogosHtml() : ""}
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        )
    }

    render() {
        return (
            <div className="animated fadeIn">
                <div className="row">

                    <div className="col-md-12 mb-4">
                        <button id="btnSaveHauteDetails" type="button" className="btn btn-primary float-right"
                                onClick={this.saveHomepage.bind(this)}
                        >
                            <i className="fa fa-floppy-o" aria-hidden="true"></i> SAVE
                        </button>
                    </div>

                    <div className="col-md-12 mb-4">
                        <Nav tabs className="nav-justified">
                            <NavItem>
                                <NavLink
                                    className={classnames({active: this.state.activeTab === '1'})}
                                    onClick={() => {
                                        this.toggle('1');
                                    }}
                                >
                                    <i className="fa fa-picture-o" aria-hidden="true"></i> Banner
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({active: this.state.activeTab === '2'})}
                                    onClick={() => {
                                        this.toggle('2');
                                    }}
                                >
                                    <i className="fa fa-h-square" aria-hidden="true"></i> About us
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({active: this.state.activeTab === '3'})}
                                    onClick={() => {
                                        this.toggle('3');
                                    }}
                                >
                                    <i className="fa fa-soundcloud" aria-hidden="true"></i> Island logos
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="1">

                                {!$.isEmptyObject(this.state.HauteDetails) ? this.renderBanner() : ""}

                            </TabPane>
                            <TabPane tabId="2">
                                {!$.isEmptyObject(this.state.HauteDetails) ? this.renderAboutus() : ""}
                            </TabPane>
                            <TabPane tabId="3">
                                {!$.isEmptyObject(this.state.HauteDetails) ? this.renderIslandLogos() : ""}
                            </TabPane>
                        </TabContent>
                    </div>

                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/HauteManagement/HomePage/HomePage.js